export default __webpack_public_path__ + "static/media/vision.02c411b9.jpg";